export const FETCH_LOAD_TRASH_PROJECT_REQUEST = 'FETCH_LOAD_TRASH_PROJECT_REQUEST'
export const FETCH_LOAD_TRASH_PROJECT_SUCCESS = 'FETCH_LOAD_TRASH_PROJECT_SUCCESS'
export const FETCH_LOAD_TRASH_PROJECT_FALUIRE = 'FETCH_LOAD_TRASH_PROJECT_FALUIRE'
export const FETCH_SEARCH_TPROJECT='FETCH_SEARCH_TPROJECT'
